/**
 * useRouter Composable
 * 
 * Type-safe wrapper around Vue Router's useRouter.
 * Provides consistent API with other core composables.
 * 
 * @example
 * ```typescript
 * import { useRouter } from '@/composables/core/useRouter';
 * 
 * const router = useRouter();
 * router.push('/dashboard');
 * ```
 */

import { useRouter as baseUseRouter, Router } from 'vue-router';

/**
 * Get the Vue Router instance with full type safety
 */
export function useRouter(): Router {
  return baseUseRouter();
}


